/**
 * Generated by `./scripts/prebuild/generate-icons.ts`.
 * Run `yarn generate-icons` to regenerate.
 */

import React from 'react';
import { findClosestGlyphAvailable, Icon } from "../../";
export function IconPlaybackSpeed1Point2x(props) {
  var _props$autoMirror;
  /* prettier-ignore */
  var iconList = [{
    'size': 16,
    'svgContent': '<path d=\'M12.641 1.74c-.735 0-1.216.529-1.216 1.09v.35h-1.5v-.35c0-1.47 1.235-2.59 2.715-2.59a2.568 2.568 0 0 1 2.61 2.752 2.5 2.5 0 0 1-1.315 2.022l-.518.282a49.36 49.36 0 0 0-.53.29 3.66 3.66 0 0 1-.124.066c-.179.094-.435.227-.703.468a1.925 1.925 0 0 0-.336.387h3.292v1.5h-5.014v-.75c0-1.053.543-1.792 1.055-2.253.256-.23.515-.401.718-.52a5.665 5.665 0 0 1 .327-.18l.017-.008.025-.013-.002.001c.092-.052.351-.193.6-.328l.466-.255c.32-.177.515-.448.548-.836.045-.533-.38-1.125-1.116-1.125zM4.402.704c0 .307-.347.763-1.044.763h-.276v1.5h1.32v5.042h1.5V.704h-1.5zm10.907 9.826-1.97 1.97 1.97 1.97-1.06 1.06-1.97-1.97-1.97 1.97-1.06-1.06 1.969-1.97-1.97-1.97 1.06-1.06 1.97 1.97 1.97-1.97 1.06 1.06zM8 8.42a.956.956 0 1 0 0-1.913.956.956 0 0 0 0 1.913z\'/>'
  }, {
    'size': 24,
    'svgContent': '<path d=\'M16.171 4.555c0-1.02.87-1.945 2.146-1.945 1.302 0 2.066 1.054 1.985 2.017-.059.693-.412 1.183-.979 1.497-.163.09-.454.249-.753.41a83.308 83.308 0 0 0-.95.521l-.046.024-.027.014-.105.054a8.875 8.875 0 0 0-.408.225 6.958 6.958 0 0 0-1.116.81c-.793.714-1.622 1.847-1.622 3.456v1h7.822v-2h-5.605c.175-.378.44-.697.743-.969a5.317 5.317 0 0 1 1.173-.78c.071-.037.133-.069.183-.098.138-.078.492-.27.858-.469.305-.165.619-.336.822-.448 1.106-.613 1.883-1.67 2.002-3.078C22.47 2.728 20.852.61 18.317.61c-2.269 0-4.146 1.712-4.146 3.945v.56h2v-.56zm5.871 12.042L19.5 19.14l2.543 2.543-1.414 1.414-2.543-2.543-2.543 2.543-1.414-1.415 2.543-2.542-2.543-2.543 1.414-1.415 2.543 2.543 2.543-2.543 1.414 1.415zm-9.343-4.883a.96.96 0 1 1-1.92 0 .96.96 0 0 1 1.92 0zM7.002.985c0 .634-.679 1.42-1.87 1.42h-.443v2h2.313v8.269h2V.985h-2z\'/>'
  }];
  var closestSize = findClosestGlyphAvailable(iconList, props.iconSize || 24);
  var titleTag = function titleTag(title, titleId) {
    return title ? "<title ".concat(titleId ? "id=\"".concat(titleId, "\"") : "", ">").concat(title, "</title>") : "";
  };
  var descTag = function descTag(desc, descId) {
    return desc ? "<desc ".concat(descId ? "id=\"".concat(descId, "\"") : "", ">").concat(desc, "</desc>") : "";
  };
  var autoMirror = (_props$autoMirror = props.autoMirror) !== null && _props$autoMirror !== void 0 ? _props$autoMirror : false;
  return /*#__PURE__*/React.createElement(Icon, Object.assign({}, props, {
    autoMirror: autoMirror,
    viewBox: "0 0 ".concat(closestSize.size, " ").concat(closestSize.size),
    dangerouslySetInnerHTML: {
      __html: "".concat(titleTag(props.title, props.titleId)).concat(descTag(props.desc, props.descId)).concat(closestSize.svgContent)
    }
  }));
}
/**
 * @deprecated The name IconPlaybackSpeed1point2x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point2x (with 'Point' capitalized) instead.
 */
export function IconPlaybackSpeed1point2x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed1Point2x, props);
}

/**
 * @deprecated The name Experimental__IconPlaybackSpeed1Point2x is deprecated and will be archived soon. Use IconPlaybackSpeed1Point2x instead.
 */
export function Experimental__IconPlaybackSpeed1Point2x(props) {
  return /*#__PURE__*/React.createElement(IconPlaybackSpeed1Point2x, props);
}